import { render } from "./cutBox.vue?vue&type=template&id=37b9f7ba&scoped=true"
import script from "./cutBox.vue?vue&type=script&lang=js"
export * from "./cutBox.vue?vue&type=script&lang=js"

import "./cutBox.vue?vue&type=style&index=0&id=37b9f7ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b9f7ba"]])

export default __exports__